// extracted by mini-css-extract-plugin
export var promoIcon = "SmallPromoIcon-module--promoIcon--db5f3";
export var promoIconContainer = "SmallPromoIcon-module--promoIconContainer--16ae5";